// Local-time date helpers. Using `new Date().toISOString()` returns UTC, which
// flips to "tomorrow" in the user's local afternoon (e.g. anywhere west of UTC).
// These helpers keep every "today" reference in the app anchored to the
// browser's local timezone.

export function localDateStr(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function localDateOffset(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return localDateStr(d);
}
